import React, { Component } from 'react';
import ButtonNew from '../../components/Button/Button';
import { domainName } from '../../config';
import './SecondaryUserHome.scss';
import firebase from '../../utils/firebase';
import { globalVal } from '../../global/globalvalues';
import SimpleHeader from '../../components/Header/simpleHeader';

type initialProps = {
    history: any;
};
type initialState = {
    user: any;
};

export class SecondaryUserHome extends Component<initialProps, initialState> {
    constructor(props: initialProps) {
        super(props);
    }
    state: initialState = {
        user: null,
    };

    componentDidMount() {
        let user1: any = localStorage.getItem('customerDetail');
        user1 = JSON.parse(user1);
        this.setState({
            user: user1,
        });
    }

    handleLogout = () => {
        localStorage.clear();
        firebase
            .auth()
            .signOut()
            .then(() => {
                localStorage.removeItem('currentuser');
                localStorage.removeItem('accessToken');
                localStorage.clear();
            })
            .catch(err => {
                console.log(err);
            });
        this.props.history.push('/home');
    };

    render() {
        const { user } = this.state;
        return (
            <div className={`${domainName && domainName === 'TEMP1' ? 'loginMain-wow' : 'loginMain-reach'} loginMain`}>
                <SimpleHeader history={this.props.history} user={user} />
                <div className="LoginPage loginPage">
                    <div className="LoginCard">
                        <div className="Title">Hi {user?.displayName},</div>
                        <div className="erroruserText">
                            It seems like you are not yet active on {globalVal?.long_name}. Please check with your group
                            owner for activation of your mobile number.
                        </div>
                        <ButtonNew
                            primary={true}
                            // variant="contained"
                            onClick={this.handleLogout}
                            className="backToHome"
                        >
                            Back to Home
                        </ButtonNew>
                    </div>
                </div>
            </div>
        );
    }
}

export default SecondaryUserHome;
